import PropTypes from 'prop-types';
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { MOBILE, DESKTOP, TABLET, DEFAULT } from './internal/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const devicePropTypes = [MOBILE, DESKTOP, TABLET, DEFAULT];
const EPDeviceSelectButton = ({
  buttonClassName,
  buttonSize = 'small',
  className,
  defaultValue = MOBILE,
  devices = [{
    name: MOBILE
  }, {
    name: DESKTOP
  }, {
    name: TABLET
  }, {
    name: DEFAULT
  }],
  onChange
}) => {
  const [activeButton, setActiveButton] = useState(defaultValue);
  const onClickHandler = e => {
    onChange(e);
    setActiveButton(e.target.value);
  };
  const children = devices.reduce((acc, device) => {
    let deviceName;
    let icon;
    let tooltip;
    if (typeof device === 'object') {
      deviceName = device.name;
      icon = device.icon;
      tooltip = device.tooltip;
    } else {
      deviceName = device;
    }
    if (devicePropTypes.includes(deviceName) || tooltip && icon) {
      acc.push( /*#__PURE__*/_jsx(UIIconButton, {
        active: activeButton === deviceName,
        "data-test-id": `toggle-${deviceName}-button`,
        size: buttonSize,
        className: buttonClassName,
        use: "tertiary-light",
        value: deviceName,
        tooltip: tooltip || /*#__PURE__*/_jsx(FormattedMessage, {
          message: `epDeviceSelectButton.${deviceName}`
        }),
        onClick: e => onClickHandler(SyntheticEvent(deviceName, e)),
        children: /*#__PURE__*/_jsx("div", {
          style: deviceName === TABLET ? {
            fontSize: 13
          } : {},
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: icon || deviceName
          })
        })
      }, deviceName));
    }
    return acc;
  }, []);
  return /*#__PURE__*/_jsx(UIButtonGroup, {
    className: className,
    children: children
  });
};
EPDeviceSelectButton.propTypes = {
  buttonClassName: PropTypes.string,
  buttonSize: PropTypes.string,
  className: PropTypes.string,
  defaultValue: PropTypes.oneOf(devicePropTypes).isRequired,
  devices: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    name: PropTypes.oneOf(devicePropTypes).isRequired,
    tooltip: PropTypes.node,
    icon: PropTypes.string
  }), PropTypes.string])).isRequired,
  onChange: PropTypes.func.isRequired
};
export default EPDeviceSelectButton;